import { render, staticRenderFns } from "./turnCount.vue?vue&type=template&id=0ea6733a&scoped=true&"
import script from "./turnCount.vue?vue&type=script&lang=js&"
export * from "./turnCount.vue?vue&type=script&lang=js&"
import style0 from "./turnCount.vue?vue&type=style&index=0&id=0ea6733a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6733a",
  null
  
)

export default component.exports